import axios from './../http'

function query(data) {
    return axios.post('/sys/dict/query', data);
}

function save(data) {
    return axios.post('/sys/dict/save', data);
}

function get(id) {
    return axios.get('/sys/dict/info?id=' + id);
}

function select(id) {
    return axios.get('/sys/dict/select?id=' + id);
}

function del(data) {
    return axios.post('/sys/dict/delByIds', data);
}

export default {
    query,
    select,
    get,
    save,
    del
}